import { Component, OnInit } from '@angular/core';
import { PinService, IPin } from "./pin.service";

@Component( {
  selector: 'pin',
  templateUrl: 'pin.component.html'
} )

export class PinComponent implements OnInit {



  allPins: string;//Array<IPin>
  constructor ( pins: PinService ) {
    this.allPins = JSON.stringify( pins.getAllPins() );
  }



  ngOnInit () { }
}
